import { HelpPage } from "@features/help/pages/HelpPage/dynamic";
import { getAppStaticProps } from "@features/ssr/utils/getAppStaticProps";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = getAppStaticProps(
  async (ctx, store) => {
    return {
      props: {},
    };
  }
);

export default HelpPage;
